export default "__VITE_ASSET__C15Tjuat__"